import { Uploader } from "uploader";

const uploader = new Uploader({
  apiKey: process.env.REACT_APP_UPLOADER_KEY,
});

export const uploadImage = ({ cropShape, cropRatio, onUploaded }) => {
  uploader
    .open({
      styles: {
        colors: {
          primary: "#ed2a26",
          active: "#c72127",
        },
      },
      maxFileSizeBytes: 1073741824,
      multi: false,
      mimeTypes: ["image/jpeg", "image/png", "image/webp", "image/svg+xml"],
      editor: { images: { cropShape, cropRatio } },
    })
    .then(onUploaded);
};

export const uploadVideo = (onUploaded) => {
  uploader
    .open({
      styles: {
        colors: {
          primary: "#ed2a26",
          active: "#c72127",
        },
      },
      maxFileSizeBytes: 5368709120,
      multi: false,
      showFinishButton: true,
      mimeTypes: [
        "video/mp4",
        "video/quicktime",
        "video/x-msvideo",
        "video/x-ms-wmv",
      ],
    })
    .then(onUploaded);
};

export const uploadAttachment = (onUploaded) => {
  uploader
    .open({
      styles: {
        colors: {
          primary: "#ed2a26",
          active: "#c72127",
        },
      },
      maxFileSizeBytes: 1073741824,
      multi: true,
      showFinishButton: true,
      mimeTypes: [
        "image/jpeg",
        "image/png",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/pdf",
        "application/zip",
      ],
      editor: { images: { crop: false } },
    })
    .then(onUploaded);
};
